import { useTranslation } from "react-i18next";

const suitableItems = [
  "contact.info.suitable1",
  "contact.info.suitable2",
  "contact.info.suitable3",
  "contact.info.suitable4",
  "contact.info.suitable5",
  "contact.info.suitable6",
  "contact.info.suitable7",
  "contact.info.suitable8",
];

export default function ContactInfoSection() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-cream">
      <div className="container-main px-4 md:px-8 lg:px-12">
        <div className="text-center mb-10 md:mb-14">
          <span className="tag-label mb-3 inline-block">{t("contact.info.label")}</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {/* LINE@ Card */}
          <div className="bg-white rounded-xl p-6 md:p-8 border border-warm-gray/30 text-center transition-all duration-300 hover:-translate-y-1 hover:border-[#06C755]/30 hover:shadow-md group">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#06C755]/10 mx-auto mb-4 transition-all duration-300 group-hover:scale-110 group-hover:bg-[#06C755]/15">
              <span className="w-7 h-7 flex items-center justify-center">
                <i className="ri-line-fill text-[#06C755] text-2xl transition-transform duration-300 group-hover:scale-110" />
              </span>
            </div>
            <h3 className="font-semibold text-graphite text-[1.125rem] mb-1">LINE@</h3>
            <p className="text-medium-gray text-base mb-4">{t("contact.info.lineId")}</p>
            <a
              href="https://lin.ee/OpssTIM"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#06C755] text-white rounded-full text-base font-semibold transition-all duration-300 hover:bg-[#05b34d] hover:-translate-y-0.5 whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-line-fill" />
              </span>
              {t("contact.info.lineBtn")}
            </a>
          </div>

          {/* Service Scope Card */}
          <div className="bg-white rounded-xl p-6 md:p-8 border border-warm-gray/30 text-center transition-all duration-300 hover:-translate-y-1 hover:border-champagne/30 hover:shadow-md group">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-champagne/10 mx-auto mb-4 transition-all duration-300 group-hover:scale-110 group-hover:bg-champagne/15">
              <span className="w-7 h-7 flex items-center justify-center">
                <i className="ri-map-2-line text-champagne text-2xl transition-transform duration-300 group-hover:scale-110" />
              </span>
            </div>
            <h3 className="font-semibold text-graphite text-[1.125rem] mb-1">
              {t("contact.info.scopeTitle")}
            </h3>
            <p className="text-medium-gray text-base">{t("contact.info.scope")}</p>
          </div>

          {/* Suitable Topics Card */}
          <div className="bg-white rounded-xl p-6 md:p-8 border border-warm-gray/30 transition-all duration-300 hover:-translate-y-1 hover:border-champagne/30 hover:shadow-md group">
            <div className="text-center mb-4">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-champagne/10 mx-auto mb-4 transition-all duration-300 group-hover:scale-110 group-hover:bg-champagne/15">
                <span className="w-7 h-7 flex items-center justify-center">
                  <i className="ri-question-answer-line text-champagne text-2xl transition-transform duration-300 group-hover:scale-110" />
                </span>
              </div>
              <h3 className="font-semibold text-graphite text-[1.125rem]">
                {t("contact.info.suitableTitle")}
              </h3>
            </div>
            <div className="flex flex-wrap gap-2 justify-center">
              {suitableItems.map((item) => (
                <span
                  key={item}
                  className="inline-block px-3 py-1 rounded-full bg-champagne/10 text-champagne text-base font-medium transition-all duration-200 hover:bg-champagne/20 hover:scale-105 cursor-default"
                >
                  {t(item)}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}